import { make } from 'vuex-pathify';
import GraphQL from '../../api/graphql';

const state = {
    items: [],
    selected: {},
    items_term: []
};

const mutations = make.mutations(state);

const actions = {
    async delete({ dispatch, rootState }, id) {
        if (id === undefined) {
            throw new Error('Necessário a ID da pesquisa para removê-la');
        }

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const response = await client.query({
            query: `
                mutation($id: ID!) {
                    deleteFavoriteSearch(id: $id)
                }
            `,
            variables: {
                id
            }
        });

        const isDeleted = response.data.deleteFavoriteSearch;
        if (!isDeleted) {
            throw new Error('Não foi possível deletar a busca selecionada. Tente novamente mais tarde.');
        }

        await dispatch('fetch');
    },
    async massDelete({ dispatch, rootState }, ids) {
        if (ids === undefined) {
            throw new Error('Necessário a ID da pesquisa para removê-la');
        }

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const response = await client.query({
            query: `
                mutation($ids: [ID!]!) {
                    deleteFavoriteSearches(ids: $ids)
                }
            `,
            variables: {
                ids
            }
        });

        const isDeleted = response.data.deleteFavoriteSearches;
        if (!isDeleted) {
            throw new Error('Não foi possível deletar a(s) buscas selecionadas. Tente novamente mais tarde.');
        }

        await dispatch('fetch');
    },
    async fetch({ rootState }) {
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const response = await client.query({
            query: `
                query {
                    favoriteSearches {
                        id
                        term
                    }
                }
            `,
            variables: {}
        });

        var items_term = [];
        
        const items = response.data.favoriteSearches.map((search) => {
            items_term.push(search.term);
            return { ...search };
        }); 

        this.set('favoriteSearches/items', items);
        this.set('favoriteSearches/items_term', items_term);
    },
    reset() {
        this.set('favoriteSearches/items', []);
        this.set('favoriteSearches/items_term', []);
        this.set('favoriteSearches/selected', {});
    },
    async save({ dispatch, rootState }, { term }) {
        if (term === undefined) {
            throw new Error('O campo "termo" é obrigatório. Por favor tente novamnete mais tarde');
        }

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        await client.query({
            query: `
                mutation($term: String!) {
                    createFavoriteSearch(term: $term)
                }
            `,
            variables: {
                term
            }
        });

        await dispatch('fetch');
    },
    async share({ rootState }, { ids, email }) {
        if (ids === undefined) {
            throw new Error('O campo "ids" é obrigatório');
        }

        if (email === undefined) {
            throw new Error('O campo "email" é obrigatório');
        }

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        ids.forEach(async (id) => {
            await client.query({
                query: `
                    mutation($id: ID!, $email: String!) {
                        shareSearch(id: $id, email: $email)
                    }
                `,
                variables: {
                    id,
                    email
                }
            });
        });

        return true;
    }
};

export default { state, mutations, actions };
